import { Base, getClosestParent, getInstanceFromElement } from "@studiometa/js-toolkit";
import { domScheduler, clamp } from "@studiometa/js-toolkit/utils";
import { layoutIsVertical, layoutIs } from "../store/index.js";
import ResizableCursor from "./ResizableCursor.js";
import ResizableSync from "./ResizableSync.js";
class Resizable extends Base {
  static config = {
    name: "Resizable",
    components: {
      ResizableCursor,
      ResizableSync
    },
    emits: ["dragged"]
  };
  previousSize = 0;
  get visibleResizeSync() {
    return this.$children.ResizableSync.filter(
      (resizableSync) => resizableSync.$el.offsetParent !== null
    );
  }
  async onResizableCursorDragged({
    target,
    args: [props]
  }) {
    const { axis } = target.$options;
    let method = "resize";
    const isVertical = await layoutIsVertical();
    if (isVertical && axis === "y" || !isVertical && axis === "x") {
      method = "resizeSync";
    }
    this[method](props.mode, target.$options.axis, props.distance, target);
    this.$emit("dragged", props);
  }
  async resize(mode, axis, distance) {
    if (await layoutIs("right") || await layoutIs("bottom")) {
      distance.x *= -1;
      distance.y *= -1;
    }
    if (mode === "start") {
      domScheduler.read(() => {
        const size = axis === "x" ? "offsetWidth" : "offsetHeight";
        this.previousSize = this.$el[size];
      });
    } else if (mode === "drag") {
      domScheduler.write(() => {
        const size = axis === "x" ? "width" : "height";
        const minSize = 8;
        const maxSize = axis === "x" ? window.innerWidth : window.innerHeight - 48;
        const newSize = clamp(distance[axis] + this.previousSize, minSize, maxSize);
        this.$el.style[size] = `${newSize}px`;
      });
    }
  }
  resizeSync(mode, axis, distance, resizableCursor) {
    const { visibleResizeSync } = this;
    if (visibleResizeSync.length === 2) {
      visibleResizeSync[0]?.sync(mode, axis, distance[axis]);
      visibleResizeSync[1]?.sync(mode, axis, distance[axis] * -1);
      return;
    }
    const parent = getClosestParent(resizableCursor, ResizableSync);
    const next = parent ? getInstanceFromElement(parent.$el.nextElementSibling, ResizableSync) : null;
    if (!next) {
      return;
    }
    parent.sync(mode, axis, distance[axis]);
    next.sync(mode, axis, distance[axis] * -1);
    for (const resizableSync of this.$children.ResizableSync) {
      if (resizableSync !== next && resizableSync !== parent) {
        resizableSync.set(axis);
      }
    }
  }
  reset() {
    domScheduler.write(() => {
      this.$el.style.width = "";
      this.$el.style.height = "";
    });
    this.$children.ResizableSync.forEach((resizable) => resizable.reset());
  }
}
export {
  Resizable as default
};
//# sourceMappingURL=Resizable.js.map
